import { RestorePoints } from '@common/models';

export class RestorePointHelper {
  static updateStorage<K extends keyof RestorePoints>(
    storage: RestorePoints | null | undefined,
    key: K,
    dateTime: string | null | undefined
  ): RestorePoints | null {
    const updated: RestorePoints = { ...(storage ?? {}) };

    if (dateTime) {
      updated[key] = dateTime;
    } else {
      delete updated[key];
    }

    return Object.keys(updated).length > 0 ? updated : null;
  }
}
